/* eslint-disable array-callback-return */
import React from "react";

import Calendar1 from "assets/icons/calendar-1.svg";
import Calendar2 from "assets/icons/calendar-2.svg";
import Calendar3 from "assets/icons/calendar-3.svg";
import Calendar4 from "assets/icons/calendar-4.svg";
import Calendar5 from "assets/icons/calendar-5.svg";
import Calendar6 from "assets/icons/calendar-6.svg";
import Calendar7 from "assets/icons/calendar-7.svg";
import Calendar8 from "assets/icons/calendar-8.svg";
import Calendar9 from "assets/icons/calendar-9.svg";
import Calendar10 from "assets/icons/calendar-10.svg";
import Calendar11 from "assets/icons/calendar-11.svg";
import Calendar12 from "assets/icons/calendar-12.svg";
import FrequencyOptionCard from "./FrequencyOptionCard";
import CardGrid from "../CardGrid";

const lessSubscriptionFrequency = [
    {
        id: 1,
        title: "3 weeks",
        image: Calendar3,
        interval: 3,
        period: "week",
    },
    {
        id: 2,
        title: "4 weeks",
        image: Calendar4,
        interval: 4,
        period: "week",
    },
    {
        id: 3,
        title: "6 weeks",
        image: Calendar6,
        interval: 6,
        period: "week",
    },
    {
        id: 4,
        title: "8 weeks",
        image: Calendar8,
        interval: 8,
        period: "week",
    },
];

const moreSubscriptionFrequency = [
    {
        id: 5,
        title: "Every week",
        image: Calendar1,
        interval: 1,
        period: "week",
    },
    {
        id: 6,
        title: "2 weeks",
        image: Calendar2,
        interval: 2,
        period: "week",
    },
    {
        id: 1,
        title: "3 weeks",
        image: Calendar3,
        interval: 3,
        period: "week",
    },
    {
        id: 2,
        title: "4 weeks",
        image: Calendar4,
        interval: 4,
        period: "week",
    },
    {
        id: 7,
        title: "5 weeks",
        image: Calendar5,
        interval: 5,
        period: "week",
    },
    {
        id: 3,
        title: "6 weeks",
        image: Calendar6,
        interval: 6,
        period: "week",
    },
    {
        id: 8,
        title: "7 weeks",
        image: Calendar7,
        interval: 7,
        period: "week",
    },
    {
        id: 4,
        title: "8 weeks",
        image: Calendar8,
        interval: 8,
        period: "week",
    },
    {
        id: 9,
        title: "9 weeks",
        image: Calendar9,
        interval: 9,
        period: "week",
    },
    {
        id: 10,
        title: "10 weeks",
        image: Calendar10,
        interval: 10,
        period: "week",
    },
    {
        id: 11,
        title: "11 weeks",
        image: Calendar11,
        interval: 11,
        period: "week",
    },
    {
        id: 12,
        title: "12 weeks",
        image: Calendar12,
        interval: 12,
        period: "week",
    },
];

const isSameFrequency = (option, frequency) =>
    Boolean(frequency) &&
    option.interval === frequency.interval &&
    option.period === frequency.period;

// Always moves the current plan to the front, whether or not it's already in
// the list. When keepLength is set and the current plan wasn't in the list,
// the last option is dropped so the row stays the same length.
const orderOptions = (options, currentFrequency, keepLength) => {
    if (!currentFrequency) return options;

    const currentOption =
        options.find((option) => isSameFrequency(option, currentFrequency)) ||
        moreSubscriptionFrequency.find((option) =>
            isSameFrequency(option, currentFrequency)
        ) || {
            id: "current",
            title: `${currentFrequency.interval} ${currentFrequency.period}${
                currentFrequency.interval > 1 ? "s" : ""
            }`,
            interval: currentFrequency.interval,
            period: currentFrequency.period,
        };

    const rest = options.filter(
        (option) => !isSameFrequency(option, currentFrequency)
    );
    const ordered = [currentOption, ...rest];

    return keepLength ? ordered.slice(0, options.length) : ordered;
};

const FrequencySection = ({
    frequency,
    currentFrequency,
    onFrequencySelect,
    showMore,
}) => {
    return (
        <CardGrid
            override={{
                xs: 6,
                sm: 6,
                md: 4,
                lg: 3,
                xl: 3,
            }}
        >
            {(showMore
                ? orderOptions(moreSubscriptionFrequency, currentFrequency)
                : orderOptions(
                      lessSubscriptionFrequency,
                      currentFrequency,
                      true
                  )
            ).map((frequencyOption) => (
                <FrequencyOptionCard
                    key={frequencyOption.id}
                    title={frequencyOption.title}
                    active={isSameFrequency(frequencyOption, frequency)}
                    current={isSameFrequency(frequencyOption, currentFrequency)}
                    onClick={() =>
                        onFrequencySelect({
                            interval: frequencyOption.interval,
                            period: frequencyOption.period,
                        })
                    }
                />
            ))}
        </CardGrid>
    );
};

export default FrequencySection;
